module.exports = __webpack_public_path__ + "static/media/v2.15f5b007.png";